import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_ACCOUNT_DETAILS: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Action',
    width: 100,
    type: 'action',
    alignClass: 'text-start',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
  },
  {
    dataKey: 'name',
    label: 'Practice Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'contactPersonName',
    label: 'Contact Person',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'contactPhone',
    label: 'Phone',
    width: 200,
    type: 'phone',
  },
  { dataKey: 'contactEmail', label: 'Email', width: 150, type: 'text' },
  {
    dataKey: 'fullAddress',
    label: 'Location Address',
    width: 300,
    type: 'text',
  },
];

export const TABLE_CONFIG_COLUMNS_CHAINS_LINKED: DyTableColumn[] = [
  {
    dataKey: 'name',
    label: 'Chain Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'activationDate',
    label: 'Activation Date',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'requestedDate',
    label: 'Requested Date',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'status',
    label: 'Status',
    width: 100,
    type: 'status',
  },
  {
    dataKey: 'actions',
    label: 'Action',
    width: 100,
    type: 'action',
    alignClass: 'text-start',
    actions: [
      {
        name: 'accept',
        iconName: 'accept-green',
      },
      {
        name: 'decline',
        iconName: 'decline-red',
      },
    ],
  },
  {
    dataKey: 'initiatedBy',
    label: 'Initiated By',
    width: 150,
    type: 'text',
  },
];
